import { Subject } from 'rxjs';

import { Component, OnDestroy } from '@angular/core';

import { SnCameraGroup } from '@lib/api/entities';
import { snDetailExpand, snFadeIn, snFadeOut, snListStagger } from '@lib/common/animations';
import { SnTableBaseComponent } from '@lib/core';

@Component({
  selector: 'sn-camera-group-table',
  templateUrl: './camera-group-table.component.html',
  styleUrls: ['./camera-group-table.component.scss'],
  animations: [snListStagger, snFadeIn, snFadeOut, snDetailExpand],
})
export class CameraGroupTableComponent
  extends SnTableBaseComponent<SnCameraGroup>
  implements OnDestroy
{
  private readonly _destroy$ = new Subject();

  constructor() {
    super();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public trackBy(index: number, item: SnCameraGroup): any {
    return item.id;
  }
}
